import { ProfileService } from 'src/app/services/profile/profile.service';
import {
  AuthFlowState,
  AuthFlowStateEventType,
  AuthWorkFlow,
  FlowType,
  PincodeNativeStatus,
  ScreenType,
} from 'src/app/models/pin-code.model';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { AuthFlowService } from 'src/app/services/auth-flow/auth-flow.service';
import { EventBusService, EventTopic } from 'src/app/services/event-bus/event-bus.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-optional',
  templateUrl: './optional.component.html',
  styleUrls: ['./optional.component.scss'],
})
export class OptionalComponent implements OnInit {
  @Input() state: AuthFlowState;
  @Input() isCurrent: boolean;
  @Input() isOnline: boolean;
  @Output() sendResetLink = new EventEmitter();

  disableNextBtn = false;
  toast: HTMLIonToastElement;

  constructor(
    public authFlowSvc: AuthFlowService,
    private profileSvc: ProfileService,
    private eventBusSvc: EventBusService,
    private toastSvc: ToastService,
    private translateSvc: TranslateService
  ) {}

  ngOnInit() {}

  async next() {
    if (this.disableNextBtn) {
      return;
    }

    this.disableNextBtn = true;
    setTimeout(() => {
      this.disableNextBtn = false;
    }, 1000);

    if (this.authFlowSvc.flowType === FlowType.setup && [ScreenType.optional, ScreenType.extra].includes(this.state.currentScreen)) {
      await this.profileSvc.getProfile();
      this.authFlowSvc.setPinStatus();
      const workflow = await this.authFlowSvc.getCurrentWorkflow();
      if (workflow !== AuthWorkFlow.setup) {
        this.closeToast();
        this.toast = await this.toastSvc.showOfflineToast(
          this.translateSvc.instant('PinPage.enterYourPin'),
          this.translateSvc.instant('ToastMessages.pincodeAlreadySet'),
          { position: 'top' }
        );
        this.closeToast(5000);
        this.eventBusSvc.publish(EventTopic.AuthFlowStateEventType, { type: AuthFlowStateEventType.updateWorkflow }, true);
      }
    }
    this.authFlowSvc.next();
  }

  closeToast(timeout = 0) {
    if (this.toast) {
      setTimeout(() => {
        this.toast.dismiss();
        this.toast = null;
      }, timeout);
    }
  }

  skip() {
    this.authFlowSvc.setStatus(PincodeNativeStatus.skipped);
  }

  get isNextBtnDisabled(): boolean {
    return !this.isOnline || this.disableNextBtn;
  }

  async reset() {
    this.sendResetLink.emit(true);
  }
}
